import type { Cache, UpdatesConfig } from '@urql/exchange-graphcache';

import invalidateQuery from '../util/invalidateQuery';

import type { AbTestCreateMutation, AbTestCreateMutationVariables, AbTestsQueryVariables } from '@/graphql/generated/graphql';

const abTest: UpdatesConfig['Mutation'] = {
  abTestCreate: (data: AbTestCreateMutation, __: AbTestCreateMutationVariables, cache: Cache) => {
    const vars: Partial<AbTestsQueryVariables> = {};
    if (data.abTestCreate.renters_implementation_id) {
      vars.renters_implementation_id = data.abTestCreate.renters_implementation_id;
    } else if (data.abTestCreate.tuition_implementation_id) {
      vars.tuition_implementation_id = data.abTestCreate.tuition_implementation_id;
    }
    invalidateQuery<AbTestsQueryVariables>('abTests', cache, vars);
    invalidateQuery<AbTestsQueryVariables>('abTests', cache);
  },
};

export default abTest;
